import { FC } from "react";
import Stack from "@mui/material/Stack";
import { UtilizationAndCoverageMetadataCosts } from "@/components/pages/commtiments/utilization-and-coverage/components/metadata/UtilizationAndCoverageMetadataCosts";
import { UtilizationAndCoverageMultiTypeChart } from "@/components/pages/commtiments/utilization-and-coverage/components/content/chart/multi-type-chart/UtilizationAndCoverageMultiTypeChart";

export const UtilizationAndCoverageMetadataV2: FC = () => {
  return (
    <Stack
      flexDirection={{ xs: "column", md: "row" }}
      gap={1}
      px={1}
      minHeight={216}
    >
      <Stack flex={7}>
        <UtilizationAndCoverageMetadataCosts />
      </Stack>
      <Stack flex={5}>
        <UtilizationAndCoverageMultiTypeChart />
      </Stack>
    </Stack>
  );
};
